import { render, staticRenderFns } from "./deleteButton.vue?vue&type=template&id=cc12b9c2&"
import script from "./deleteButton.vue?vue&type=script&lang=js&"
export * from "./deleteButton.vue?vue&type=script&lang=js&"
import style0 from "./deleteButton.vue?vue&type=style&index=0&id=cc12b9c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports